export default __webpack_public_path__ + "static/media/question-mark.b2eb40af.svg";